import { tWithKeyAttr as t } from "../../i18nHelper";
import styles from "./questionReport.module.css";
import {
  TQuestionnaire,
  TQuestionnaireQuestion,
} from "../../services/types/user.types";
import { getMimeType } from "../../utils/utils";
import { resolveFileUrl } from "../../utils/fileUrl";
import AppAudio from "../appMedia/AppAudio";
import FilePreview from "../filePreview/FilePreview";

// DataTypesId 7 answers are a JSON array [{ url, mimeType }], or a comma-separated
// list of URLs for older records.
const parseFileAnswer = (answer: string): { url: string; mimeType: string }[] => {
  try {
    return JSON.parse(answer);
  } catch {
    return answer.split(",").map((url) => ({
      url: url.trim(),
      mimeType: getMimeType(url.trim()),
    }));
  }
};

function QuestionReport({
  report,
}: {
  report: { questionnaire: TQuestionnaire; results: TQuestionnaireQuestion[] };
}) {
  const renderAnswer = (q: TQuestionnaireQuestion) => {
    if (q.DataTypesId === 10 && q.Answer?.startsWith("data:image/png")) {
      return (
        <img
          src={q.Answer}
          alt={t('SIGNATURE_IMAGE')}
          className={styles.signatureImg}
        />
      );
    }

    if (q.DataTypesId === 6 && q.Answer) {
      const resolved = resolveFileUrl(q.Answer.trim());
      if (resolved && (/^https?:\/\//i.test(resolved) || resolved.includes("/api/files/"))) {
        return <AppAudio controls className={styles.audioPlayer} src={resolved} />;
      }
    }

    if (q.DataTypesId === 7 && q.Answer) {
      const entries = parseFileAnswer(q.Answer);
      if (entries.length === 0) return <p className={styles.text}>-</p>;
      return (
        <div className={styles.fileListWrapper}>
          {entries.map((entry) => (
            <FilePreview
              key={entry.url}
              file={{
                name: entry.url.substring(entry.url.lastIndexOf("/") + 1),
                type: entry.mimeType,
              }}
              previewUrl={resolveFileUrl(entry.url.trim()) ?? entry.url.trim()}
            />
          ))}
        </div>
      );
    }

    return <p className={styles.text}>{q.Answer || "-"}</p>;
  };

  return (
    <ul className={`${styles.list} scroll scroll_thin scroll_rounded`}>
      <li className={` ${styles.li} ${styles.li_header}`}>
        <p className={styles.text}>{t('QUESTION')}</p>
        <p className={styles.text}>{t('ANSWER')}</p>
        <p className={styles.text}>{t('SCORE')}</p>
      </li>
      {report.results.length > 0 ? (
        report.results.map((q, index) => (
          <li key={index} className={styles.li}>
            <p className={styles.text}>{q.Desc}</p>
            {renderAnswer(q)}
            <p className={styles.text}>{q.Score}</p>
          </li>
        ))
      ) : (
        <p className={styles.noResults}>{t('NO_RESULTS_FOUND')}</p>
      )}
    </ul>
  );
}

export default QuestionReport;
